import React from 'react';
import { Link } from 'react-router-dom';
import IconSocalFurs from './Socalfurs.jpg';
import './Footer.css'
import wolp from './wolp.jpg'
import wolpSound from './wolp.mp3'

export default function Footer() {


  const playSound = () => {
    const audio = new Audio(wolpSound); // Path to your sound file
    audio.play();
  };
  
  // const [open, setOpen] = useState(false);
  // const [close, setCloseNav] = useState(false);
  // const menuRef = useRef();
  // const linkRef = useRef();

  
  // // Close dropdown when clicking outside
  // useEffect(() => {
  //   function handleClickOutside(event) {
  //     if (menuRef.current && !menuRef.current.contains(event.target)) {
  //       setOpen(false);
  //     }
  //   }
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);


  return (
    <nav className = "footer-nav-container">

      <div className="left-info">
        <div className = "icon-name-container">
          <Link to = "/" className = "navbar-name">SocalFurs</Link> 

          <Link to = "/"> 
            <img src={IconSocalFurs} alt="Socalfurs.com" className="navbar-icon" />
          </Link>
        </div>

        <span className='disclaimer'>
          LEGAL DISCLAIMER:
          All events are independently operated, our calendar only lists them in one place. 
          We are not responsible for events, and any issues should be directed to the event organizers.
        </span>
      </div>

      <div className="wolp-container">
        <div className = "powered-container-3">
          <p className = "wolp-text">🐾Powered by wolp girl and friends🐾</p> 
          <p className = "brie-text">🧀🏳️‍⚧️we love brieee🏳️‍⚧️🧀</p>
        </div>

        <div className = "wolp-img-container">
          <img onClick = {playSound}   className = "wolp-img" src = {wolp} alt="Sillywolp" />
          <div className = "powered-container">
            <p>🐾Powered by wolp girl and friends🐾</p> 
            <p>🧀we love brieee🧀</p>
          </div>
        </div>

        <div className = "powered-container-2">
          <p>🐾Powered by wolp girl and friends🐾</p> 
          <p>🧀🏳️‍⚧️we love brieee🏳️‍⚧️🧀</p>
        </div>
      </div>


    </nav>
  );
}





